<template>
	<div v-bar @dragover="allowDrop" id="approot" ref="approot" :style="{width: ispreview?'375px':''}"><div>
		<div v-if="logined && ! ispreview" class="header" :style="{height: `${headerh}px`,'z-index': iseditor?1:100}">
			<img class="logo fl" :src="logo" :title="page_title" />
			<div class="fl" style="color:#ccc;padding-top:17px;">{{page_subtitle}}</div>
			<div class="fr" style="line-height:50px;" v-if="logined">
				<template v-if="iseditor">
					<label @click="showFile" class="btnli"><i class="iconfont icon-wenjianguanli"></i>
					文件管理</label>
					<label @click="showSetting" class="btnli"><i class="iconfont icon-shezhi"></i>
					设置</label>
					<label @click="onSave" class="btnli"><i class="iconfont icon-save"></i>
					保存</label>
				</template>
				<template v-else>
					<Poptip v-if="version.length" @on-popper-show="updateVersion" trigger="hover" placement="bottom"
					 word-wrap="true" width="380">
					 	<template v-if="syslog.id">
							<div slot="title" style="font-weight: bold;font-size: 14px;">{{syslog.created}} V{{syslog.version}}</div>
							<div slot="content" style="width: 348px;overflow: hidden;">
								<p style="line-height: 1.5;font-size: 14px;padding: 5px 0 8px;white-space: normal;">{{syslog.remark}}</p>
								<ul id="syslogs"><li v-for="(txt, idx) in JSON.parse(syslog.content||'[]')" :key="idx">{{txt}}</li></ul>
								<a :href="logsmore" class="syslog-history" target="_blank">更多历史更新日志</a>
							</div>
						</template>
						<template v-else><p slot="title" style="color: #999;">未发现更新日志</p></template>
			            <Badge dot :count="vscnt" style="color: #999;margin-right: 15px;">更新日志</Badge>
			        </Poptip>
					<a :href="helper" target="_blank" class="helper">帮助文档</a>
					<label>{{loguser}}</label>
					<i @click="logout" class="iconfont icon-tuichu logout" title="登出"></i>
				</template>
			</div>
		</div>

		<div class="main" v-if="logined" :style="{'margin-top': ispreview?'0px':'50px',height: ispreview?'100%':''}">
			<div v-if="! ispreview" :class="['sidebar', 'fl', {'editor-bar': iseditor}]" ref="sidebar">
				<sidebar :iseditor="iseditor" :height="containerh"></sidebar>
			</div>
			<div class="content fl" ref="content" :style="ctstyle">
				<weditor :id="pageid" :height="containerh" :ispreview="ispreview" v-if="iseditor || ispreview"></weditor>
				<component :is="`Mc${cmpalias}`" :type="cmptype" v-else></component>
			</div>
		</div>

		<file-manager :fmtype="filemgr_type" :con_height="con_height" :multiselect="filemgr_multiselect"
		:con_main_left_height="con_main_left_height" v-if="show_filedialog && !ispreview"></file-manager>
		
		<login v-if="! logined"></login>
		<Modal title="温馨提示" v-model="buildAppTip" class-name="vertical-center-modal" :closable="false" :mask-closable="false"
		 ok-text="马上绑定" cancel-text="先体验一下" @on-ok="onBuild" @on-cancel="onTaste">
			<p style="font-size: 14px;">部分功能需要授权绑定小程序后才能体验</p>
		</Modal>
		<Modal title="温馨提示" v-model="siteError" class-name="vertical-center-modal siterr" :closable="false" :mask-closable="false">
			<p style="font-size: 14px;">抱歉，{{siteErrTips}}</p>
			<div slot="footer">&nbsp;&nbsp;</div>
		</Modal>
	</div></div>
</template>

<script>
import jGlobal from '@/global';
import McTips from '@/components/tips';
import Weditor from '@/components/editor';
import Sidebar from '@/components/sidebar';
import Login from '@/modules/login/login';
import EventBus from '@/common/events';
import FileManager from '@/components/file-manager';
//import defaultlogo from '@/assets/logo.jpg';

export default
{
	name: 'app',
	data (){
		return {
			iseditor: false,
			cmpalias: 'Tips',
			cmptype: 'loading',
			pageid: 0,
			containerh: 0,
			headerh: jGlobal.HEADERH,
			logined: true,
			loguser: '',
			ispreview: false,
			winheight: 0,
			filemgr_type: '',
			filemgr_multiselect: false,
			show_filedialog: false,
			buildAppTip: false,
			siteError: false,
			siteErrTips: '',
			page_title: '',
			page_subtitle: '',
			logo: '',
			helper: '',
			logsmore: '',
			vscnt: 1,
			version: '',
			syslog: {},
		}
	},
	computed: {
		ctstyle (){
			let ispreview = this.ispreview, width = 'calc(100% - 300px)',
			mleft = ispreview ? '0px' : '30px';
			if (this.iseditor) width = ispreview ? '100%' : 'calc(100% - 278px)';
			return  {width,'margin-left': mleft}
		},
		con_height (){
			return (parseFloat(this.winheight) - 37 * 2 - 7) * 0.9 + 'px'
		},
		con_main_left_height (){
			return Math.max(245, (parseFloat(this.winheight) - 37 * 2 - 7) * 0.9 - 35 - 132 + 30) + 'px'
		},
	},
	created (){
		let deflogo = `${window.hosturl}image/logo.png?v=1.0`;
		this.helper = `${window.hosturl}index/help`;
		this.logsmore = `${window.hosturl}index/logs`;
		this.page_title = window.page_title || '';
        this.page_subtitle = window.page_subtitle || '';
		// for 'site-status'
		this.ispreview = jGlobal.isPreview();
		let pageid = jGlobal.isEditor();
		if (pageid) {this.pageid = pageid;this.iseditor = true}
		// for 'customer-scrollbar'
		this.$nextTick(() => {
			let that = this, headerh = that.headerh, domroot = that.$refs.approot,
			sidebar = that.$refs.sidebar, content = that.$refs.content;
			$(window).on("resize", function(e, type = ''){
				let winh = $(this).height();
				that.winheight = winh;
				if (!type) {
					$(domroot).height(winh);
					let $target = $([]), csidx = 'min-height';
					if (that.iseditor) {
						csidx = 'height';
						that.containerh = winh - headerh;
						$target = $('.baseplugin, .propanel', that.$el)
					} $target = $('> ul', sidebar);
					$target.add([sidebar, content]).css(csidx, `${winh - headerh}px`);
					if (that.ispreview) $(content).height(winh)
				}
				!that.iseditor && that.$vuebar.refreshScrollbar(domroot)
			}).trigger("resize");

			if (that.iseditor && that.$vuebar.getState(domroot)) {
				that.$vuebar.destroyScrollbar(domroot)
			}
		});
		// for 'resize-listener'
		EventBus.$on("winresize", v => $(window).trigger("resize", [v]));
		// 'File-manager' listener
		EventBus.$on("show_filemanager", (ishow, callback, ftype = 'all', multiselect = false) => {
			this.show_filedialog = ishow || false;
			if (!ishow) {EventBus.$off("select_picture");return false}
			this.filemgr_type = ftype;
			this.filemgr_multiselect = multiselect;
			// 'Select-picture' listener
			if (! $.isFunction(callback)) return false;
			EventBus.$once("select_picture", res => {
				callback.call(null, res);
				this.show_filedialog = false
			})
		});
		// for 'oauth'
		jGlobal.getUserInfo(res => {
			let userinf = res.data || {};
			if (res.result == 'ERROR') {
				this.initComp();
				return false
			}
			// for 'site-status'
			let errmsg = jGlobal.checkSiteStatus(userinf);
			if (errmsg.length > 0) {
				this.siteError = true;
				this.siteErrTips = errmsg;
				return false
			}

			this.logined = true;
			this.loguser = userinf.account;
			// for 'version'
			this.version = userinf.version || '';
			// for 'logo'
			let extra = JSON.parse(userinf.extra || '{}');
			this.logo = extra.logo || deflogo;
			// for 'editor-pause'
			if (this.iseditor) return false;
			// for '是否绑定小程序提示'
			if (this.$cookie.get('wxappbuild') != '1') {
				jGlobal.xhrPost('wxapp/configset', null, res => {
					this.buildAppTip = $.isEmptyObject(userinf)
				})
			} else this.buildAppTip = false;

			let [mod, act] = jGlobal.getModAct(),
			curcomp = jGlobal.ucFirst(mod) + jGlobal.ucFirst(act);
			//this.logined.referer = curcomp;
			// for 'success'
			this.cmpalias = curcomp;
			let shortpath = `${mod}/${act}`;
			EventBus.$emit("sidebar_menuactived", shortpath);
			this.$options.components[`Mc${curcomp}`] = resolve => {
	        	require.ensure([], require => {
		            let reqc = require.context("@/modules", true, /^\.\/.+?\/.+?.vue$/);

		            try {
		            	let loaded = reqc(`./${shortpath}.vue`);
		            	if (loaded) resolve(loaded)
		            	else throw 'not found'
		            } catch (err) {
		            	this.cmpalias = 'Tips';mod = '404';
		            	EventBus.$emit("sidebar_menuactived", '')
		            }
		            this.cmptype = mod
				}, 'mod');
			}
		}, err => this.initComp());
		// for 'Get offical-version information'
		jGlobal.xhrPost('user/logs', null, res => {
			this.vscnt = res.data.vscnt || 0;
			this.syslog = res.data.logs || {}
		})
	},
	methods: {
		updateVersion (){
			var vscnt = this.vscnt || 0;
			if (! vscnt) return false;
			this.vscnt = 0;
			// for 'update local-version'
			jGlobal.xhrPost('user/logvs', {'vs': this.version})
		},
		showFile (){
			EventBus.$emit("show_filemanager", true)
		},
		showSetting (){
			EventBus.$emit("show_setting", true)
		},
		onSave (){
			EventBus.$emit("pagesave")
		},
		initComp (){
			this.cmpalias = 'Tips';
			this.cmptype = 'loading';
			this.logined = false
		},
		allowDrop (e){
			if (!this.editor) return true;
			e.preventDefault();
			if (/firefox/i.test(navigator.userAgent)) window.event = e;
			return true
		},
		logout (){
			jGlobal.xhrPost('user/logout', null, res => {
				location.search = 'admin=index/index'
			})
		},
		onTaste (){
			this.$cookie.set('wxappbuild', '1');
		},
		onBuild (){
			this.$cookie.set('wxappbuild', '1');
			location.search = '?admin=wxapp/publish'
		}
	},
	components: {McTips, Login, Weditor, Sidebar, FileManager},
}
</script>

<style type="text/css">
[v-cloak] {display: none;}
#syslogs li {list-style-type: square;list-style-position: outside;margin: 0 0 0 25px;font-size: 14px;width: 323px;line-height: 1.5;white-space: normal;}
.siterr .ivu-modal-footer {border-top: none !important;padding: 0 !important;}
.ivu-message {z-index: 10001!important;}
.vertical-center-modal {display: flex;align-items: center;justify-content: center;}
.vertical-center-modal .ivu-modal {top: 0;}
.header-tips {background: #eff1f3;margin-bottom: 15px;color: #353535;line-height: 50px;padding-left: 20px;}
.content .pages-list {width: 100%;}
.content .pages-list thead {color: #909399;font-weight: 500;}
.content .pages-list tr {background-color: #fff;}
.content .pages-list th, .content .pages-list td {padding: 12px 0;min-width: 0;-webkit-box-sizing: border-box;box-sizing: border-box;text-overflow: ellipsis;vertical-align: middle;position: relative;white-space: nowrap;overflow: hidden;user-select: none;text-align: center;border-bottom: 1px solid #ebeef5;}
.content .pages-list .cell {font-size: 14px;-webkit-box-sizing: border-box;box-sizing: border-box;white-space: normal;word-break: break-all;line-height: 23px;color: #666;overflow: visible;display: inline-block;position: relative;word-wrap: normal;text-overflow: ellipsis;vertical-align: middle;width: 100%;}
.content .pages-list td .isplit::after {content: "|";margin: 0 4px;color: #333;}
.content .pages-list td .portrait {border-radius: 50%;-webkit-border-radius: 50%;-moz-border-radius: 50%;width: 50px;height: 50px;margin: 0 auto;overflow: hidden;}
.content .pages-list td .portrait > img {border: 0;width: 50px;height: 50px;margin: 0;padding: 0;}
</style>
<style scoped>
#approot {font-size: 14px;}
.header {background: #fff;position: fixed;top: 0;left: 0;right: 0;padding: 0 24px;}
.header .logo {height: 60px;width: auto;margin-top: -5px;margin-right: 10px;}
.header .btnli {cursor: pointer;margin: 0 5px;}
.header .logout {cursor: pointer;margin-left: 5px;font-size: 18px;}
.main {background-color: #f6f8f9;margin-top: 50px;min-height: calc(100% - 50px);position: relative;overflow: hidden;z-index: 1;}
.sidebar {padding: 0;box-sizing: border-box;width: 240px;}
.content {margin-left: 30px;width: calc(100% - 278px);}
.editor-bar {border-right: 1px solid #dddee1;overflow: hidden;}
.helper {border: 1px solid #2d8cf0;border-radius: 3px;padding: 5px 15px;font-size: 12px;margin-right: 15px;}
.syslog-history {cursor: pointer;color: #2d8cf0;display: inline-block;line-height: 35px;margin-top: 15px;border-top: 1px solid #ddd;text-align: center;font-size: 14px;width: 100%;}
</style>


// WEBPACK FOOTER //
// App.vue?726b8c22